module.exports = __webpack_public_path__ + "img/colored-rounded.0106ee41.svg";